// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2XK5I","title":"InfoRow_title__3OpXN"};